module.exports = __webpack_public_path__ + "static/img/keshi1.8275f3ba.webp";